// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import axios from 'axios'
import 'weui';
import weui from 'weui.js';
// 按需引入部分组件
import { Toast } from 'mint-ui';
Vue.component(Toast.name, Toast);
import { Indicator } from 'mint-ui'
Vue.prototype.$indicator = Indicator
import { Swipe, SwipeItem } from 'mint-ui';
import { MessageBox } from 'mint-ui';
Vue.prototype.$messagebox = MessageBox
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
import VueWechatTitle from 'vue-wechat-title'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueScroller from 'vue-scroller'  // 触底加载
import md5 from 'js-md5'

Vue.prototype.$md5 = md5

Vue.use(VueScroller) // 使用组件

Vue.use(ElementUI);

Vue.use(VueWechatTitle)

import VueSweetalert2 from './plugins/vue-sweetalert2';
import 'font-awesome/css/font-awesome.min.css';
import 'mint-ui/lib/style.css';


// 根据路由设置标题
router.beforeEach((to, from, next) => {
    /*路由发生改变修改页面的title */
    if(to.meta.title) {
      document.title = to.meta.title
    }
    next();
})


Vue.use(VueSweetalert2)

Vue.use(Lazyload);


Vue.use(Vant);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  weui,
    axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js